export const stylesColoPicker = {
    colorButton: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
    },
    colorPreview: {
        width: 36,
        height: 36,
        borderRadius: '50%',
        border: '2px solid #000',
        marginRight: 10,
    },
    popover: {
        marginTop: 8,
    },
}